import React from 'react'
import AdminWrapper from '../AdminWrapper'
import AdminNavItem from './AdminNavItem'
import { useTranslation } from 'react-i18next'
import { NavItemsProps } from '../../Layout/NavItem'
import { BusinessCenterOutlined, EditNotificationsOutlined, EmojiEventsOutlined, InfoOutlined, ListAltOutlined, NotificationsActiveOutlined, NotificationsNoneOutlined, PublicOutlined, ReportProblemOutlined, RequestQuoteOutlined, ShoppingCartOutlined, TrackChangesOutlined, TrendingUpOutlined, BarChartOutlined, SummarizeOutlined, CalculateOutlined, QueryStatsOutlined, TuneOutlined } from '@mui/icons-material'
import { BoxSeam, Boxes, Collection } from 'react-bootstrap-icons'
import { MenuBookOutlined, MilitaryTech, GroupWorkOutlined, SquareFootOutlined, DesignServices } from '@mui/icons-material';
import { Collapse, Divider } from '@mui/material'
import { useThemeContext } from '../../../theme/ThemeContext'

const AdminNavItems: React.FC<NavItemsProps> = (props) => {
  const { t } = useTranslation("menu");
  const [open, setOpen] = React.useState(false);
  const [openDownload, setOpenDownload] = React.useState(false);
  const [openNotification, setOpenNotification] = React.useState(false);
  const [openGoal, setOpenGoal] = React.useState(false);
  const { theme } = useThemeContext()

  const handleClick = () => {
    setOpen(!open);
  };

  const handleDownloadClick = () => {
    setOpenDownload(!openDownload);
  };

  const handleNotificationClick = () => {
    setOpenNotification(!openNotification);
  };

  const handleGoalClick = () => {
    setOpenGoal(!openGoal);
  };

  return <AdminWrapper>
    <AdminNavItem
      uri='clients'
      title={t('clients')}
      icon='people'
      {...props}
    />

    <AdminNavItem
      uri='people'
      title={t('people')}
      icon='contacts'
      {...props}
    />

    <AdminNavItem
      uri='vendors'
      title={t('vendors')}
      icon={<BusinessCenterOutlined />}
      {...props}
    />


    <AdminNavItem
      uri='products'
      title={t('products')}
      nested
      icon={<Boxes />}
      onClick={handleClick}
      openItem={open}
      {...props}
    />

    <Collapse in={open} timeout="auto" style={{
      marginTop: open ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: open ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <AdminNavItem
        uri='products'
        title={t('products')}
        icon={<BoxSeam />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='productSections'
        title={t('sections')}
        icon={<MenuBookOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='productBrands'
        title={t('brands')}
        icon={<MilitaryTech />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='productGroups'
        title={t('groups')}
        icon={<Collection />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='productSubgroups'
        title={t('subgroups')}
        icon={<GroupWorkOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='productMeasurements'
        title={t('measurements')}
        icon={<SquareFootOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='productMeasurementTypes'
        title={t('measurementTypes')}
        icon={<DesignServices />}
        subItem
        {...props}
      />
    </Collapse>

    <AdminNavItem
      uri='preorders'
      title={t('preorders')}
      icon={<ShoppingCartOutlined />}
      {...props}
    />

    <AdminNavItem
      uri='complaints'
      title={t('complaintsList')}
      icon={<ReportProblemOutlined />}
      {...props}
    />

    <AdminNavItem
      uri='goals'
      title={t('goals')}
      icon={<TrackChangesOutlined />}
      nested
      onClick={handleGoalClick}
      openItem={openGoal}
      {...props}
    />

    <Collapse in={openGoal} timeout="auto" style={{
      marginTop: openGoal ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openGoal ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <AdminNavItem
        uri='goals'
        title={t('adminGoals')}
        icon={<EmojiEventsOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='goals-constant-average'
        title={t('adminAverageGoals')}
        icon={<CalculateOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='goals2weight-tier-admin'
        title={t('goals2weightTierAdmin')}
        icon={<TuneOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='person-objective-prizes'
        title={t('personObjectivePrizes')}
        icon={<MilitaryTech />}
        subItem
        {...props}
      />
      <Divider sx={{ marginLeft: 3.7, marginRight: 1.7, borderColor: theme.palette.primary.main }} />
      <AdminNavItem
        uri='goals-stats-client'
        title={t('clientGoals')}
        icon={<BarChartOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='goals-stats-vendor'
        title={t('vendorGoals')}
        icon={<TrendingUpOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='vendorClientBrandMatrix'
        title={t('averageGoals')}
        icon={<QueryStatsOutlined />}
        subItem
        {...props}
      />
    </Collapse>

    <AdminNavItem
      uri='downloads'
      title={t('downloadReport')}
      nested
      icon={<InfoOutlined />}
      onClick={handleDownloadClick}
      openItem={openDownload}
      {...props}
    />

    <Collapse in={openDownload} timeout="auto" style={{
      marginTop: openDownload ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openDownload ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <AdminNavItem
        uri='dlPriceList'
        title={t('priceList')}
        icon={<RequestQuoteOutlined />}
        subItem
        {...props}
      />

      <AdminNavItem
        uri='currentAccountSummary'
        title={t('currentAccountSummary')}
        icon={<SummarizeOutlined />}
        subItem
        {...props}
      />

    </Collapse>

    <AdminNavItem
      uri='notifications'
      title={t('notifications')}
      nested
      icon={<NotificationsNoneOutlined />}
      onClick={handleNotificationClick}
      openItem={openNotification}
      {...props}
    />

    <Collapse in={openNotification} timeout="auto" style={{
      marginTop: openNotification ? props.open ? "-16px" : "-6px" : "0px",
      marginBottom: openNotification ? props.open ? "-16px" : "-6px" : "-16px"
    }}>
      <AdminNavItem
        uri='massNotifications'
        title={t('sendMassNotifications')}
        icon={<EditNotificationsOutlined />}
        subItem
        {...props}
      />
      <AdminNavItem
        uri='notifications'
        title={t('myNotifications')}
        icon={<NotificationsActiveOutlined />}
        subItem
        {...props}
      />
    </Collapse>

    <AdminNavItem
      uri='countries'
      title={t('countries')}
      icon={<PublicOutlined />}
      {...props}
    />
    <AdminNavItem
      uri='logs'
      title={t('logs')}
      icon={<ListAltOutlined />}
      {...props}
    />
  </AdminWrapper>
}

export default AdminNavItems
